import { Component, Inject, inject } from "@angular/core";
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from "@angular/material/bottom-sheet";
import { MatListModule } from "@angular/material/list";

@Component({
    selector: 'bottom-sheet-overview-example-sheet',
    templateUrl: 'activity-bottom-sheet.component.html',
    standalone: true,
    imports: [MatListModule],
  })
  export class BottomSheetOverviewExampleSheet {

    constructor(
        @Inject(MAT_BOTTOM_SHEET_DATA) public data: any
      ) {}
      
    private _bottomSheetRef =
      inject<MatBottomSheetRef<BottomSheetOverviewExampleSheet>>(MatBottomSheetRef);
  
    addActivity(event: MouseEvent): void {
     this._bottomSheetRef.dismiss({ action: 'create', leadId: this.data?.leadId });
     event.preventDefault();
    }

    skipActivity(event: MouseEvent): void {
        this._bottomSheetRef.dismiss({ action: 'skip' });
        event.preventDefault();
      }
  }
  
